export const writeToClipboard = (element?: HTMLInputElement): Promise<void> => {
  if (element) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(element.value);
    }
    // ClipboardApi fallback
    element.select();
    const result = document.execCommand("copy");
    if (result) {
      return Promise.resolve();
    }
    return Promise.reject();
  }
  return Promise.reject();
};

export const writeTextToClipboard = (
  text: string | undefined
): Promise<void> => {
  if (text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    // ClipboardApi fallback
    const el = document.createElement("textarea");
    el.value = text;
    document.body.appendChild(el);
    el.select();
    const result = document.execCommand("copy");
    document.body.removeChild(el);
    if (result) {
      return Promise.resolve();
    }
    return Promise.reject();
  }
  return Promise.reject();
};
